import axios from "axios";
import { returnErrors } from "../../store/reducers/error";

export const liveUrl = "https://api.equityedge.co.uk/";
export const devUrl = "https://dev-api.equityedge.co.uk/";
export const uatUrl = "https://backend-uat.equityedge.co.uk/"; //uat server

export const baseUrl = (() => {
  const { hostname } = window.location;

  if (hostname === "localhost") {
    return uatUrl;
  } else if (hostname === "dev-admin.equityedge.co.uk") {
    return devUrl;
  } else if (hostname === "equityedge-admin-uat.netlify.app") {
    return devUrl;
  } else if (hostname === "admin-uat.equityedge.co.uk") {
    return uatUrl;
  } else if (hostname === "super.equityedge.co.uk") {
    return liveUrl;
  }
  return liveUrl;
})();

const signupRequest = async (formdata) => {
  const response = await axios.post(`${baseUrl}auth/register/`, formdata);
  return response;
};

//User
const getUserDetailsnew = async (idToken, data) => {
  //removed clg
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.get(
      `${baseUrl}auth/admin/update-user-details/?email=${data}`,
      config,
    );
    if (response.status === 201 || response.status === 200) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};
const updateUserDetailsnew = async (idToken, data) => {
  //removed clg
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.patch(
      `${baseUrl}auth/admin/update-user-details/`,
      data,
      config,
    );
    if (response.status === 201 || response.status === 200) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};

const getUserDetails = async (idToken) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const output = await axios
    .get(`${baseUrl}user/profile/`, config)
    .then((res) => {
      return res.data;
    })
    .catch(function (error) {
      return error;
    });
  return output;
};

// UserAddress
const getUserAddress = async (idToken) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const output = await axios
    .get(`${baseUrl}user/billing/address/`, config)
    .then((res) => {
      return res.data;
    })
    .catch(function (error) {
      return error;
    });
  return output;
};

// Post
const addUserAddress = async (idToken, data) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const output = await axios
    .post(`${baseUrl}user/billing/address/`, data, config)
    .then((res) => {
      return res.data;
    })
    .catch(function (error) {
      return error;
    });
  return output;
};

// Patch
const updateUserAddress = async (idToken, data) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const output = await axios
    .patch(`${baseUrl}user/billing/address/`, data, config)
    .then((res) => {
      return res.data;
    })
    .catch(function (error) {
      return error;
    });
  return output;
};

const updateUserDetailsRequest = async ({ formData, idToken }) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  let output;
  await axios
    .patch(`${baseUrl}user/profile/`, formData, config)
    .then((res) => {
      output = res.data;
      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });
  return output;
};

const loadUser = async (idToken) => {
  let config = {
    headers: {
      Authorization: "Bearer " + idToken,
    },
  };
  let output;
  await axios
    .get(`${baseUrl}auth/user/`, config)
    .then((res) => {
      output = res;
      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });
};

//funding

const getFundingDetails = async (idToken, selectedBrand) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params: {
      ...(selectedBrand?.brand === "crypto_edge"
        ? { crypto: true }
        : { crypto: false }),
    },
  };
  let output;
  await axios
    .get(`${baseUrl}account/funding-evaluation/`, config)
    .then((res) => {
      output = res;
      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

//support
const getSupportTableDetails = async (
  idToken,
  pageNumber,
  type,
  severity,
  status,
  search,
) => {
  const params = {
    page: pageNumber,
    page_size: 50,
  };
  if (type) {
    params.type = typeof type === "string" ? type : type.value;
  }
  if (severity) {
    params.severity = severity.value;
  }
  if (status) {
    params.status = status.value;
  }
  if (search) {
    params.user = search;
    params.page = 1;
  }
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
    params: params,
  };
  let output;
  await axios
    .get(`${baseUrl}support/admin/case/`, config)
    .then((res) => {
      output = res.data;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};
const getSupportTableDetailsNew = async (
  idToken,
  pageNumber,
  type,
  severity,
  status,
  search,
  platform,
  selectedBrand,
  duplicatesBrowser,
) => {
  const params = {
    page: pageNumber,
    page_size: 50,
    ...(selectedBrand?.brand === "crypto_edge" ? { crypto: true } : {}),
  };
  if (type) {
    params.account_type = typeof type === "string" ? type : type.value;
  }
  if (severity) {
    params.severity = severity.value;
  }
  if (status) {
    params.status = status.value;
  }
  if (search) {
    params.search = search;
    params.page = 1;
  }
  if (platform) {
    params.platform = platform;
  }
  if (duplicatesBrowser) {
    params.duplicates = duplicatesBrowser;
  }
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
    params: params,
  };
  let output;
  await axios
    .get(`${baseUrl}account/admin/contracts/`, config)
    .then((res) => {
      output = res.data;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

const updateSupportDetails = async (idToken, id, formData) => {
  const apiUrl = `${baseUrl}support/admin/case/${id}`;

  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  let output;
  await axios
    .patch(apiUrl, formData, config)
    .then((res) => {
      if (res?.response?.stauts > 399) {
        output = res;
        return output;
      }
      output = res;
      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });
  return output;
};

const deleteSupportDetails = async (idToken, id) => {
  const apiUrl = `${baseUrl}support/admin/case/${id}`;

  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.delete(apiUrl, config);

    return response;
  } catch (error) {
    return error;
  }
};

//Certificates
const getCertificatesDetails = async (
  idToken,
  pageNumber,
  search,
  newSearch,
  selectedBrand,
  type,
) => {
  const params = {
    page: pageNumber,
    page_size: 20,
    ...(selectedBrand?.brand === "crypto_edge" ? { crypto: true } : {}),
  };
  if (type && type !== "all") {
    if (type === "challenge") {
      params.cert_type = "1 Step Pass,2 Step Pass";
    } else if (type === "payout") {
      params.cert_type = "Profit Split";
    } else if (type === "funded") {
      params.cert_type = "Funded";
    } else {
      params.cert_type = type;
    }
  }
  if (search !== null) {
    params.search = search;
    params.page = 1;
  } else {
    params.search = newSearch;
  }

  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
    params: params,
  };

  try {
    const response = await axios.get(
      `${baseUrl}certificate/admin/all/`,
      config,
    );
    return response;
  } catch (error) {
    return error;
  }
};

const getLifetimeCertificatesDetails = async (
  idToken,
  userId,
  search,
  newSearch,
  selectedBrand,
) => {
  const params = {
    ...(selectedBrand?.brand === "crypto_edge" ? { crypto: true } : {}),
  };

  if (userId) {
    params.user_id = userId;
  }

  if (search !== null && search !== undefined) {
    params.search = search;
    // params.page = 1;
  } else if (newSearch) {
    params.search = newSearch;
  }

  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
    params: params,
  };

  try {
    const response = await axios.get(
      `${baseUrl}user/admin/payout/lifetime-certificate/`,
      config,
    );
    return response;
  } catch (error) {
    return error;
  }
};

// TraderList

const getAllTradersRequest = async (idToken, params, selectedBrand) => {
  try {
    // const params = {
    //   page: pageNumber,
    //   page_size: 20,
    // };
    // if (searchValue !== null) {
    //   params.search = searchValue;
    //   // params.page = 1;
    // }
    // if (active === true) {
    //   params.active = "True";
    // }
    // if (active === false) {
    //   params.active = "False";
    // }
    // if (phase) {
    //   params.phase = phase.value;
    // }
    // // if (competition === true) {
    // //   params.competition = "True";
    // // }
    // // if (competition === false) {
    // //   params.competition = "False";
    // // }
    // if (tab !== null) {
    //   params.type = tab;
    // }
    // if (platform) {
    //   params.platform = platform;
    // }

    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
      params: {
        ...params,
        ...(selectedBrand?.brand === "crypto_edge" ? { crypto: true } : {}),
      },
    };

    const response = await axios.get(
      `${baseUrl}account/admin/accounts-list/`,
      config,
    );

    if (response?.status < 399) return response.data;
    if (response.response?.status > 399) {
      return {
        count: 0,
        results: [],
      };
    }
  } catch (error) {
    // dispatch(returnErrors("something went wrong", 400));
    return {
      count: 0,
      results: [],
    };
  }
};
const getSearchTradersRequest = async (idToken, competition, search) => {
  try {
    const params = {
      search: search,
    };
    if (competition === true) {
      params.competition = "True";
    }

    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
      params: params,
    };

    const response = await axios.get(
      `${baseUrl}account/admin/accounts-list/`,
      config,
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

//affiliate
const traderAffiliateRefList = async (idToken, id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
      // params: {
      //   affiliate_code_id: id,
      // },
    };
    const response = await axios.get(
      `${baseUrl}affiliates/admin/referred-list/${id}`,
      config,
    );
    return response.data;
  } catch (error) {
    console.error("Error in getting trader ref list", error);
    throw error;
  }
};
const getAffiliateDetails = async (idToken) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  let output;
  await axios
    .get(`${baseUrl}affiliates/list/`, config)
    .then((res) => {
      output = res.data;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

const getAffiliateList = async (idToken) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  let output;
  await axios
    .get(`${baseUrl}affiliates/admin/affiliate-list/`, config)
    .then((res) => {
      output = res;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};
const sendCredential = async (idToken, login_id) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  let output;
  await axios
    .post(`${baseUrl}account/admin/email-credentials/`, login_id, config)
    .then((res) => {
      output = res;
      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};
export const addBalanceRequest = async (idToken, data) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(
      `${baseUrl}payment/admin/add-balance/`,
      data,
      config,
    );
    return response;
  } catch (error) {
    return error;
  }
};
const getAffiliateListV2 = async (idToken, search, currentPage) => {
  console.log("search", search);
  const params = {
    page: currentPage,
    page_size: 21,
  };
  if (search) {
    params.search = search;
    params.page = currentPage;
  }
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params: params,
  };

  const url = `${baseUrl}affiliates/admin/affiliate-list/v2/`;
  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    return error;
  }
};

const postAffiliateDetails = async (idToken, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.post(
      `${baseUrl}affiliates/create-link/`,
      data,
      config,
    );
    if (response.status === 201 || response.status === 200) {
      return response.data;
    } else {
      console.error(
        "POST request for affiliate data failed:",
        response.status,
        response.data,
      );
      throw new Error("POST request failed");
    }
  } catch (error) {
    console.error("Error making POST request for affiliate data:", error);
    throw error;
  }
};

// User List
const getUserList = async (idToken, params) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params,
  };

  const url = `${baseUrl}auth/admin/user-list/`;

  let output;
  await axios
    .get(url, config)
    .then((res) => {
      output = res;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

const getUserReport = async (idToken, params) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params,
  };

  const url = `${baseUrl}auth/admin/user-report/`;

  let output;
  await axios
    .get(url, config)
    .then((res) => {
      output = res;
      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

//user login
const postAdminLogin = async (idToken, value) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };

  // console.log(value);
  // return
  //create a form data
  const formData = new FormData();
  formData.append("email", value.user);
  let output;
  await axios
    .post(`${baseUrl}auth/admin/custom-token/`, formData, config)
    .then((res) => {
      output = res;
      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

//Payout Apis
const getPayoutListRequest = async (
  idToken,
  search,
  method,
  payoutType,
  currentPage,
  duplicateWallets,
  planType,
  selectedBrand,
  payoutTypeValue,
) => {
  const params = {
    page: currentPage,
    page_size: 20,
    ...(selectedBrand?.brand === "crypto_edge" ? { crypto: true } : {}),
  };

  if (method) {
    params.status = method;
    // params.page = 1 || currentPage;
  }
  if (search) {
    params.search = search;
    params.page = currentPage;
  }
  if (payoutType) {
    params.payout_type = payoutType;
  }
  if (duplicateWallets) {
    params.duplicate_wallets = duplicateWallets;
  }
  if (planType) {
    params.plan_type = planType;
  }

  if (payoutTypeValue) {
    params.payout_type = payoutTypeValue;
  }

  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params: params,
  };

  const url = `${baseUrl}user/admin/payout/`;

  let output;
  await axios
    .get(url, config)
    .then((res) => {
      output = res;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

const generatePayoutRequest = async (idToken, data) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  try {
    const response = await axios.put(
      `${baseUrl}user/admin/payout/${data.id}/`,
      data?.data,
      config,
    );
    return response;
  } catch (error) {
    return error;
  }
};
const amendPayoutRequest = async (idToken, id, amount) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  try {
    const response = await axios.put(
      `${baseUrl}user/admin/amend-payout/${id}/`,
      { amended_amount: amount },
      config,
    );
    return response;
  } catch (error) {
    return error;
  }
};
const generatePayoutRequestNew = async (idToken, data) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  try {
    const response = await axios.post(
      `${baseUrl}user/admin/payout/`,
      data,
      config,
    );
    return response;
  } catch (error) {
    return error;
  }
};

const getPaymentListNew = async (idToken, params, selectedBrand) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params: {
      ...(selectedBrand?.brand === "crypto_edge" ? { crypto: true } : {}),
      ...params,
    },
  };

  const url = `${baseUrl}payment/admin/transaction-history/`;

  let output;
  await axios
    .get(url, config)
    .then((res) => {
      output = res;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};
const forcePaymentAccountCreation = async (idToken, payment_id) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  };

  const url = `${baseUrl}payment/admin/payment-force-account-creation/`;

  let output;
  await axios
    .post(url, { payment_id }, config)
    .then((res) => {
      output = res;
      return output;
    })
    .catch(function (error) {
      output = error.response || error;
      return output;
    });

  return output;
};

// Payment List
const getPaymentList = async (
  idToken,
  search,
  status,
  plan,
  currentPage,
  searchValue,
  platform,
  selectedBrand,
  paymentMode,
) => {
  const params = {
    page: currentPage,
    page_size: 21,
    ...(selectedBrand?.brand === "crypto_edge" ? { crypto: true } : {}),
  };

  if (status) {
    params.payment_status = status;
  }
  if (search) {
    params.search = search;
    params.page = search === searchValue ? currentPage : 1;
  }
  if (plan) {
    params.plan = plan;
  }
  if (platform) {
    params.platform = platform;
  }
  if (paymentMode) {
    params.payment_mode = paymentMode;
  }

  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params: params,
  };

  const url = `${baseUrl}payment/admin/transaction-history/`;

  let output;
  await axios
    .get(url, config)
    .then((res) => {
      output = res;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

const getPaymentReport = async (
  idToken,
  search,
  status,
  plan,
  currentPage,
  searchValue,
  platform,
  selectedBrand,
  exportParams = null, // ✅ NEW (optional)
) => {
  const params = {
    page: currentPage,
    page_size: 21,
    ...(selectedBrand?.brand === "crypto_edge" ? { crypto: true } : {}),
  };

  // ✅ Existing Filters
  if (status) params.payment_status = status;
  if (plan) params.plan = plan;
  if (platform) params.platform = platform;

  if (search) {
    params.search = search;
    params.page = search === searchValue ? currentPage : 1;
  }

  // ✅ ✅ EXPORT OVERRIDE (FIXES plan[export] PROBLEM)
  if (exportParams?.export === "csv") {
    delete params.page;
    delete params.page_size;

    params.export = "csv"; // ✅ THIS IS THE KEY FIX

    params.start_date = exportParams.start_date || "";
    params.end_date = exportParams.end_date || "";
    params.broker = exportParams.broker || "";
    params.payment_status = exportParams.payment_status || "";

    params.country = exportParams.country || [];
    params.plans = exportParams.plans || [];
    params.challenges = exportParams.challenges || [];
    params.user_email = exportParams.user_email || [];
    params.payment_method = exportParams.payment_method || [];
    params.promo_code = exportParams.promo_code || [];
  }

  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params: params,
    responseType: exportParams?.export === "csv" ? "blob" : "json", // ✅ AUTO SWITCH
  };

  const url = `${baseUrl}payment/admin/ee-purchase-report/`;

  let output;
  await axios
    .get(url, config)
    .then((res) => {
      output = res;
    })
    .catch((error) => {
      output = error.response;
    });

  return output;
};

// affiliate codes list
const getAffiliateCodelist = async (idToken, search, currentPage) => {
  const params = {
    page: currentPage,
    page_size: 21,
  };

  // if (status) {
  //   params.payment_status = status;
  // }
  if (search) {
    params.search = search;
    params.page = currentPage;
  }
  // if (plan) {
  //   params.plan = plan;
  // }

  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params: params,
  };

  const url = `${baseUrl}affiliates/admin/affiliate-code-list/v2/`;

  let output;
  await axios
    .get(url, config)
    .then((res) => {
      output = res;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

const getCodelistV2 = async (idToken, email) => {
  const params = {
    page_size: 1000,
  };

  if (email) {
    params.affiliate = email;
  }

  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params: params,
  };
  let output;
  await axios
    .get(`${baseUrl}affiliates/admin/affiliate-code-list/v2/`, config)
    .then((res) => {
      output = res;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

// Payment ListOLD
const getPaymentListOLD = async (idToken, status) => {
  const params = {};

  if (status) {
    params.payment_status = status;
  }
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params: params,
  };
  let output;
  await axios
    .get(`${baseUrl}payment/admin/list/`, config)
    .then((res) => {
      output = res;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

// for user status
const changeUserStatus = async (idToken, email, data) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  let output;
  await axios
    .post(`${baseUrl}auth/admin/change-user-status/?id=${email}`, data, config)
    .then((res) => {
      output = res;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};
// for reset password
const resetPassword = async (idToken, data) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  let output;
  await axios
    .post(`${baseUrl}auth/admin/reset-password/`, data, config)
    .then((res) => {
      output = res;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};
// for delete user
const deleteUser = async (idToken, email) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  let output;
  await axios
    .delete(`${baseUrl}auth/admin/delete-user/?email=${email}`, config)
    .then((res) => {
      output = res;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};
// for risk management
const getRiskManagement = async (idToken, data = {}, selectedBrand) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params: {
      ...(selectedBrand?.brand === "crypto_edge"
        ? { crypto: true }
        : { crypto: false }),
    },
  };
  try {
    const response = await axios.post(
      `${baseUrl}account/admin/risk-management-overview/v2/`,
      data,
      config,
    );
    return response;
  } catch (error) {
    return error;
  }
};

//coupon
const getCouponDetails = async (idToken, params) => {
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params: params,
  };

  try {
    const response = await axios.get(`${baseUrl}payment/admin/coupon/`, config);
    return response.data;
  } catch (error) {
    // Optionally log the error or handle it as needed
    console.error("Error fetching coupon details:", error);
    return error.response ? error.response.data : error.message;
  }
};

const postCouponDetails = async (idToken, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.post(
      `${baseUrl}payment/admin/coupon/`,
      data,
      config,
    );

    return response;
  } catch (error) {
    return error;
  }
};

const deleteCouponDetails = async (idToken, couponCode) => {
  const apiUrl = `${baseUrl}payment/admin/coupon/?coupon=${couponCode}`;

  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  };
  try {
    await axios.delete(apiUrl, config);
  } catch (error) {
    console.error("An error occurred while deleting the coupon:", error);
  }
};

const updateCouponDetails = async (idToken, data, id) => {
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.patch(
      `${baseUrl}payment/admin/coupon/?coupon=${id}`,
      data,
      config,
    );

    if (response.status < 399) {
      return response;
    } else {
      throw new Error("PATCH request failed");
    }
  } catch (error) {
    console.error("Error making PATCH request for coupon data:", error);
    throw error;
  }
};

//adv

const getAdvDetails = async (idToken) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  let output;
  await axios
    .get(`${baseUrl}marketing/admin/marketing/`, config)
    .then((res) => {
      output = res.data;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

const postAdvDetails = async (idToken, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };

    const response = await axios.post(
      `${baseUrl}marketing/admin/marketing/`,
      data,
      config,
    );

    if (response.status === 201 || response.status === 200) {
      return response.data;
    } else {
      console.error(
        "POST request for adv data failed:",
        response.status,
        response.data,
      );
      throw new Error("POST request failed");
    }
  } catch (error) {
    console.error("Error making POST request for adv data:", error);
    throw error;
  }
};

const deleteAdvDetails = async (idToken, Id) => {
  const apiUrl = `${baseUrl}marketing/admin/marketing/?advertisement_id=${Id}`;

  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.delete(apiUrl, config);

    if (response.status === 204) {
    } else {
      console.error(`Failed to delete adv with code ${Id}.`);
    }
  } catch (error) {
    console.error("An error occurred while deleting the adv:", error);
  }
};

const updateAdvDetails = async (idToken, data, id) => {
  const apiUrl = `${baseUrl}marketing/admin/marketing/?advertisement_id=${id}`;

  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  let output;
  await axios
    .patch(apiUrl, data, config)
    .then((res) => {
      output = res.data;
      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });
  return output;
};

//competition

const getCompDetails = async (idToken) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  let output;
  await axios
    .get(`${baseUrl}account/admin/competitions/`, config)
    .then((res) => {
      output = res;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

const postCompDetails = async (idToken, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.post(
      `${baseUrl}account/admin/competitions/`,
      data,
      config,
    );
    if (response.status === 201 || response.status === 200) {
      return response;
    } else {
      return response;
      // throw new Error("POST request failed");
    }
  } catch (error) {
    console.error("Error making POST request for comp data:", error);
    // throw error;
    return error;
  }
};

const deleteCompDetails = async (idToken, id) => {
  const apiUrl = `${baseUrl}account/admin/competitions/${id}`;

  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.delete(apiUrl, config);

    if (response.status === 201 || response.status === 204) {
      return response;
    }
  } catch (error) {
    return error;
    // throw error;
  }
};

const updateCompDetails = async (idToken, data, id) => {
  const apiUrl = `${baseUrl}account/admin/competitions/${id}`;

  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  };
  let output;
  await axios
    .patch(apiUrl, data, config)
    .then((res) => {
      output = res.data;
      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });
  return output;
};

//plans

const getPlansTableDetails = async (idToken) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  let output;
  try {
    await axios.get(`${baseUrl}account/admin/plans/`, config).then((res) => {
      output = res.data;

      return output;
    });
  } catch (error) {
    output = error;
    return output;
  }

  return output;
};

const updatePlanTableDetails = async (idToken, data, id) => {
  const apiUrl = `${baseUrl}account/admin/plans/${id}`;

  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  };
  let output;
  await axios
    .patch(apiUrl, data, config)
    .then((res) => {
      output = res.data;
      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });
  return output;
};

const getPlansDetails = async (idToken) => {
  try {
    let config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.get(
      `${baseUrl}account/admin/challenges/`,
      config,
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

const getChallengesDetails = async (idToken, selectedBrand) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params: {
      ...(selectedBrand?.brand === "crypto_edge"
        ? { crypto: true }
        : { crypto: false }),
    },
  };
  let output;
  await axios
    .get(`${baseUrl}account/funding-evaluation/`, config)
    .then((res) => {
      output = res;

      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

const postPlansDetails = async ({ idToken, data }) => {
  try {
    let config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.post(
      `${baseUrl}account/admin/challenges/`,
      data,
      config,
    );
    if (response.status === 201 || response.status === 200) {
      return response;
    } else {
      console.error(
        "POST request for plans data failed:",
        response.status,
        response.data,
      );
    }
  } catch (error) {
    return error;
    // throw error;
  }
};

const updatePlansDetails = async ({ idToken, data, id }) => {
  const apiUrl = `${baseUrl}account/admin/challenges/${id}`;

  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  };
  let output;

  // return
  await axios
    .patch(apiUrl, data, config)
    .then((res) => {
      output = res;
      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });
  return output;
};

const deletePlansDetails = async ({ idToken, id }) => {
  const apiUrl = `${baseUrl}account/admin/challenges/${id}`;

  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  };
  let output;
  await axios
    .delete(apiUrl, config)
    .then((res) => {
      output = res;
      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });
  return output;
};

const deletePlansTableDetails = async (idToken, id) => {
  const apiUrl = `${baseUrl}account/admin/plans/${id}`;

  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.delete(apiUrl, config);

    if (response.status === 201 || response.status === 204) {
      return true;
    }
  } catch (error) {
    return error;
    // throw error;
  }
};

const postPlansTableDetails = async (idToken, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.post(
      `${baseUrl}account/admin/plans/`,
      data,
      config,
    );
    if (response.status === 201 || response.status === 200) {
      return response;
    } else {
      console.error(
        "POST request for plans data failed:",
        response.status,
        response.data,
      );
    }
  } catch (error) {
    return error;
    // throw error;
  }
};
// import user to admin apis
const getFundingEvaluationPlansRequest = async (idToken, selectedBrand) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
      params: {
        ...(selectedBrand?.brand === "crypto_edge"
          ? { crypto: true }
          : { crypto: false }),
      },
    };
    const response = await axios.get(
      `${baseUrl}account/funding-evaluation/`,
      config,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
const getPaymentHistoryRequest = async (data) => {
  console.log("objectmahi", data);
  let config = {
    headers: {
      Authorization: `Bearer ${data.idToken}`,
    },
    params: {
      ...(data.selectedBrand?.brand === "crypto_edge" ? { crypto: true } : {}),
      email: data.email,
    },
  };
  const output = await axios
    .get(`${baseUrl}payment/admin/payment-history/`, config)
    .then((res) => {
      return res;
    })
    .catch(function (error) {
      throw error;
    });
  return output;
};
const getCompetitionListRequest = async (idToken) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.get(
      `${baseUrl}account/competition-list/`,
      config,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Leaderboard
const getLeaderboardDetailsReq = async (idToken, id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.get(
      `${baseUrl}user/competition/${id}/`,
      config,
    );
    return response;
  } catch (error) {
    return error;
  }
};

const getUserAccountListRequest = async (idToken) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const output = await axios
    .get(`${baseUrl}account/list/`, config)
    .then((res) => {
      return res.data;
    })
    .catch(function (error) {
      throw error;
    });
  return output;
};

const getAccountMetricsRequest = async ({ idToken, loginId, dispatch }) => {
  const { login_id, trading_platform, email } = loginId;

  const NewEmail = email?.replace("+", "%2B");
  try {
    if (idToken && loginId) {
      let config = {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      };

      const response = await axios.get(
        `${baseUrl}account/metrics/${login_id?.replace(
          "#",
          "%23",
        )}?trading_platform=${trading_platform}&email=${NewEmail}`,
        config,
      );
      if (response.status >= 400) {
        throw new Error(response);
      }

      return response;
    }
  } catch (error) {
    throw error;
  }
};
const getBalanceChartRequest = async ({
  idToken,
  loginId,
  start_date,
  end_date,
}) => {
  const { login_id, trading_platform, email } = loginId;
  const NewEmail = email?.replace("+", "%2B");

  try {
    if (idToken && loginId) {
      let config = {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
        params: { start_date, end_date },
      };
      const response = await axios.get(
        `${baseUrl}account/balance-equity/${login_id?.replace(
          "#",
          "%23",
        )}?trading_platform=${trading_platform}&email=${NewEmail}`,
        config,
      );

      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

// const getPayoutListRequest = async (idToken) => {
//   let config = {
//     headers: { Authorization: `Bearer ${idToken}` },
//   };
//   const output = await axios
//     .get(`${baseUrl}user/payout/list/`, config)
//     .then((res) => {
//       return res.data;
//     })
//     .catch(function (error) {
//       throw error;
//     });
//   return output;
// };
const getTraderJournalRequest = async (idToken) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const output = await axios
    .get(`${baseUrl}account/trade-journal/`, config)
    .then((res) => {
      return res.data;
    })
    .catch(function (error) {
      throw error;
    });
  return output;
};

//awards
const createAwardRequest = async (idToken, data, dispatch) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const response = await axios.post(
    `${baseUrl}account/admin/award/`,
    data,
    config,
  );

  if (response.status < 399) {
    return response;
  } else {
    dispatch(returnErrors("faild to create award", 400));
  }
};
const updateAwardRequest = async (idToken, data, dispatch) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const response = await axios.patch(
    `${baseUrl}account/admin/award/`,
    data,
    config,
  );

  if (response.status < 399) {
    return response;
  } else {
    dispatch(returnErrors("faild to create award", 400));
  }
};
// Upgrade account
const upgradeUserAccountReq = async (idToken, data) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const response = await axios.post(
    `${baseUrl}account/admin/create-account/`,
    data,
    config,
  );
  return response;
};

const upgradeFundedUserAccountReq = async (idToken, data) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const response = await axios.post(
    `${baseUrl}account/admin/funded-account-create/`,
    data,
    config,
  );
  return response;
};
const generateContractRequest = async (idToken, id, data) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const response = await axios.post(
    `${baseUrl}account/admin/generate-contract/${id}`,
    data,
    config,
  );
  return response;
};
const updateUserAccountReq = async (idToken, data) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const response = await axios.patch(
    `${baseUrl}account/admin/update-account/`,
    data,
    config,
  );
  return response;
};

const getOverviewReq = async (idToken, phase) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  const response = await axios.get(
    `${baseUrl}account/admin/account-overview/?phase=${phase}`,
    config,
  );
  return response;
};

// Create trading account apis
const UserSearchReq = async (idToken, search) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.get(
      `${baseUrl}auth/admin/search-user/?search=${search}`,
      config,
    );
    if (response.status === 201 || response.status === 200) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};
const postCouponDetailsnew = async (idToken, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.post(
      `${baseUrl}payment/admin/v2/coupon`,
      data,
      config,
    );

    return response;
  } catch (error) {
    return error;
  }
};

const GetCertificatesADMIN = async (idToken) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.get(`${baseUrl}certificate/list/`, config);
    if (response.status === 201 || response.status === 200) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};
const CreateCertificate = async (idToken, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${baseUrl}certificate/admin/create/`,
      data,
      config,
    );
    if (response.status === 201 || response.status === 200) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};

const EligibleCertificateAccount = async (idToken, email) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.get(
      `${baseUrl}certificate/admin/elible-certificates-acccounts/?email=${email}`,
      config,
    );
    if (response.status === 201 || response.status === 200) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};

const CreateTradingAccountReq = async (idToken, data) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };
  try {
    const response = await axios.post(
      `${baseUrl}account/admin/create-account/`,
      data,
      config,
    );
    return response;
  } catch (error) {
    return error;
  }
};
// IP logs
const ipLogsReq = async (idToken, search, blocked, currentPage) => {
  const params = {
    page: currentPage,
    page_size: 20,
  };
  if (blocked) {
    params.blocked = blocked;
  }
  if (search) {
    params.search = search;
    params.page = currentPage;
  }
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
      params: params,
    };
    const response = await axios.get(`${baseUrl}auth/admin/ip-logs/`, config);
    return response;
  } catch (error) {
    return error;
  }
};

// commission for payout

const getCommission = async (idToken, selectedEmail) => {
  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params: {
      email: selectedEmail,
    },
  };

  const url = `${baseUrl}user/eligible-commission/`;

  let output;
  await axios
    .get(url, config)
    .then((res) => {
      output = res;
      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

// User Profile Update

const updateUserDetailsNew = async (idToken, data) => {
  //removed clg
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.patch(
      `${baseUrl}auth/admin/update-user-details/`,
      data,
      config,
    );
    if (response.status === 201 || response.status === 200) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};

// Password Change api
const changeUserPassword = async (idToken, payload) => {
  //removed clg
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.post(
      `${baseUrl}auth/admin/change-user-password/`,
      payload,
      config,
    );
    if (response.status === 201 || response.status === 200) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    throw error;
  }
};

const getUserProfileData = async (idToken, email) => {
  const params = {
    email: email,
  };

  let config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    params: params,
  };

  const url = `${baseUrl}auth/admin/update-user-details/`;

  let output;
  await axios
    .get(url, config)
    .then((res) => {
      output = res;
      return output;
    })
    .catch(function (error) {
      output = error;
      return output;
    });

  return output;
};

const sendBrokerInboxMessage = async (idToken, payload) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    const response = await axios.post(
      `${baseUrl}account/admin/match-trader/send-inbox-message`,
      payload,
      config,
    );
    return response;
  } catch (error) {
    return error.response || error;
  }
};

export {
  updateUserDetailsRequest,
  loadUser,
  signupRequest,
  getUserAddress,
  getAffiliateCodelist,
  addUserAddress,
  updateUserAddress,
  getUserDetails,
  getFundingDetails,
  getSupportTableDetails,
  getCertificatesDetails,
  getLifetimeCertificatesDetails,
  updateSupportDetails,
  deleteSupportDetails,
  getAllTradersRequest,
  getSearchTradersRequest,
  getAffiliateDetails,
  postAffiliateDetails,
  getCouponDetails,
  postCouponDetails,
  updateCouponDetails,
  deleteCouponDetails,
  deleteUser,
  getAdvDetails,
  postAdvDetails,
  deleteAdvDetails,
  resetPassword,
  changeUserStatus,
  updateAdvDetails,
  getCompDetails,
  postCompDetails,
  deleteCompDetails,
  updateCompDetails,
  getPlansDetails,
  postPlansDetails,
  deletePlansDetails,
  updatePlansDetails,
  getPlansTableDetails,
  updatePlanTableDetails,
  deletePlansTableDetails,
  getRiskManagement,
  postPlansTableDetails,
  getFundingEvaluationPlansRequest,
  getPaymentHistoryRequest,
  getCompetitionListRequest,
  getLeaderboardDetailsReq,
  getUserAccountListRequest,
  getAccountMetricsRequest,
  getBalanceChartRequest,
  getPayoutListRequest,
  getTraderJournalRequest,
  postCouponDetailsnew,
  traderAffiliateRefList,
  getChallengesDetails,
  createAwardRequest,
  updateUserDetailsnew,
  getPaymentList,
  generateContractRequest,
  getAffiliateList,
  upgradeUserAccountReq,
  upgradeFundedUserAccountReq,
  getOverviewReq,
  updateAwardRequest,
  updateUserAccountReq,
  amendPayoutRequest,
  getPaymentListOLD,
  getUserList,
  getUserReport,
  getAffiliateListV2,
  generatePayoutRequest,
  UserSearchReq,
  CreateTradingAccountReq,
  ipLogsReq,
  EligibleCertificateAccount,
  GetCertificatesADMIN,
  CreateCertificate,
  sendCredential,
  getSupportTableDetailsNew,
  generatePayoutRequestNew,
  postAdminLogin,
  getCodelistV2,
  getUserDetailsnew,
  getUserProfileData,
  getCommission,
  updateUserDetailsNew,
  changeUserPassword,
  getPaymentListNew,
  getPaymentReport,
  forcePaymentAccountCreation,
  sendBrokerInboxMessage,
};
